import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavigationContextService {

  private STORAGE_KEY = 'nav_context';

  private getState(): any {
    const data = sessionStorage.getItem(this.STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  }

  private saveState(state: any): void {
    sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(state));
  }


  getIds(): string[] {
    const state = this.getState();
    return state || [];
  }

  addNode(nodoId: string): void {
    const state = this.getState();

    let ids: string[] = state || [];

    const id = nodoId.trim(); // 🔥 normalización

    const index = ids.indexOf(id);

    if (index !== -1) {
      ids = ids.slice(0, index + 1); // 🔥 mantiene orden
    } else {
      ids.push(id);
    }

    this.saveState(ids);
    console.log("state",ids);
  }

  addNodes(nodes: string[]): void {
    if(nodes != undefined) {
      const state = this.getState();

      let ids: string[] = state || [];

      nodes.forEach((num, index) => {
        ids.push(num);
      });

      this.saveState(ids);
      console.log("state",ids);
    }
  }

  backTo(nodoId: string): void {
    const state = this.getState();
    const ctx = state.currentContext;

    if (!ctx) return;

    let ids: string[] = state.contextos[ctx] || [];

    const index = ids.indexOf(nodoId);

    if (index !== -1) {
      ids = ids.slice(0, index + 1);
      state.contextos[ctx] = ids;
      this.saveState(state);
    }
  }
  /** 
  clearContext(contextId: string): void {
    const state = this.getState();
    delete state.contextos[contextId];
    this.saveState(state);
  }
  **/

  clearAll(): void {
    const state = [];
    this.saveState(state);
    console.log("clearAll",state);
  }
}